import React from "react";

export const Field = ({ label, name, value, onChange, type = "text", placeholder, required, error }) => (
  <div>
    <label htmlFor={name} className="block text-sm font-medium text-slate-300 mb-1.5">
      {label} {required && <span className="text-purple-400">*</span>}
    </label>
    <input
      id={name}
      name={name}
      type={type}
      value={value}
      onChange={(e) => onChange(name, e.target.value)}
      placeholder={placeholder}
      data-testid={`field-${name}`}
      className="glass-input"
    />
    {error && <p className="mt-1 text-xs text-red-400" data-testid={`error-${name}`}>{error}</p>}
  </div>
);

export const TextArea = ({ label, name, value, onChange, placeholder, required, error, rows = 3 }) => (
  <div>
    <label htmlFor={name} className="block text-sm font-medium text-slate-300 mb-1.5">
      {label} {required && <span className="text-purple-400">*</span>}
    </label>
    <textarea
      id={name}
      name={name}
      rows={rows}
      value={value}
      onChange={(e) => onChange(name, e.target.value)}
      placeholder={placeholder}
      data-testid={`field-${name}`}
      className="glass-input resize-none"
    />
    {error && <p className="mt-1 text-xs text-red-400" data-testid={`error-${name}`}>{error}</p>}
  </div>
);

export const Select = ({ label, name, value, onChange, options, required, error }) => (
  <div>
    <label htmlFor={name} className="block text-sm font-medium text-slate-300 mb-1.5">
      {label} {required && <span className="text-purple-400">*</span>}
    </label>
    <select
      id={name}
      name={name}
      value={value}
      onChange={(e) => onChange(name, e.target.value)}
      data-testid={`field-${name}`}
      className="glass-input"
    >
      <option value="">Select…</option>
      {options.map((o) => (
        <option key={o} value={o}>{o}</option>
      ))}
    </select>
    {error && <p className="mt-1 text-xs text-red-400" data-testid={`error-${name}`}>{error}</p>}
  </div>
);
